<pw-view-title>Scanner</pw-view-title>

<pw-scanner (codeScanned)="onScan($event)"></pw-scanner>

